// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i2rvh","badges":"styles_badges__3bRIc"};